/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect, useState, useContext } from 'react';

import { Column, Heading, Row, UserContext } from 'school-space-client/components';
import { getCustomerBookings } from 'school-space-client/api';
import { getYesterdaysDate } from 'school-space-utils/date';

import PastBookingCard from '../components/cards/PastBookingCard';

const css = {
    cards: theme => ({
        marginTop: theme.layout.baseline * 2
    })
};

const PastBookings = () => {
    const [bookings, setBookings] = useState([]);
    const { id: userId } = useContext(UserContext);

    useEffect(() => {
        getCustomerBookings(userId, {
            toDate: getYesterdaysDate(),
            orderByOrder: 'desc'
        })
            .then(data => {
                if (data.length > 0) {
                    setBookings(data);
                } else {
                    setBookings(null);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }, [userId]);

    return (
        <main>
            <Row>
                <Column s={[6]} m={[12]} l={[12]}>
                    <Heading level="1" size="x-large">
                        Past bookings
                    </Heading>
                </Column>
            </Row>
            <div css={css.cards}>
                {bookings ? (
                    bookings.map(booking => <PastBookingCard key={booking.id} booking={booking} />)
                ) : (
                    <p>You have no past bookings</p>
                )}
            </div>
        </main>
    );
};

export default PastBookings;
